import { useEffect, useState } from 'react';
import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';

import NotFoundPage from './NotFoundPage';
import SurveyPage from '../surveys/SurveyPage';
import MainLayout from '../../layouts/MainLayout';
import LoginPage from '../auth/LoginPage';
import ClientsListPage from '../clients/ClientsListPage';
import { isInRole } from '../auth/components/RenderForRole';
import SurveyResultsPage from '../surveys/SurveyResultsPage';
import FullLayout from '../../layouts/FullLayout';
import SurveyTestPage from '../surveys/SurveyTestPage';
import SurveysWizardPage from '../surveys/SurveysWizardPage';
import AuthService from '../auth/AuthService';
import ClientEditPage from '../clients/ClientEditPage';
import UsersListPage from '../users/UsersListPage';
import UserEditPage from '../users/UserEditPage';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux';

const Router = () => {
    const loggedIn = useSelector((state: RootState) => state.auth.loggedIn);
    const isSuperAdmin = isInRole(['superadmin']);
    const [slug, setSlug] = useState<string>();
    useEffect(() => {
        setSlug(AuthService.getClientSlug());
    }, [loggedIn]);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/">
                    {/* Default route depending on role */}
                    <Route element={<MainLayout />}>
                        <Route
                            index
                            element={<Navigate replace to={`/admin/evals`} />}
                        />
                    </Route>

                    {/* Public routes */}
                    <Route path="surveys/:muuid" element={<SurveyPage />} />
                    <Route
                        path="surveys/test/:muuid"
                        element={<SurveyTestPage />}
                    />

                    <Route
                        path=":client/surveys/:muuid"
                        element={<SurveyPage />}
                    />
                    <Route
                        path=":client/surveys/test/:muuid"
                        element={<SurveyTestPage />}
                    />

                    <Route path="login" element={<LoginPage />} />

                    {/* client admin routes */}
                    {isSuperAdmin && (
                        <Route element={<MainLayout />}>
                            <Route
                                path="admin/clients/:client/edit"
                                element={<ClientEditPage />}
                            />
                            <Route
                                path="admin/clients/new"
                                element={<ClientEditPage />}
                            />
                            <Route
                                path="admin/clients/:client/users"
                                element={<UsersListPage />}
                            />
                            <Route
                                path="admin/clients/:client/users/new"
                                element={<UserEditPage />}
                            />
                            <Route
                                path="admin/clients/:client/users/:id/edit"
                                element={<UserEditPage />}
                            />
                        </Route>
                    )}

                    {/* Routes for evals */}
                    <Route path="admin/evals">
                        <Route element={<MainLayout />}>
                            <Route
                                index
                                element={
                                    isSuperAdmin ? (
                                        <ClientsListPage />
                                    ) : (
                                        <Navigate
                                            replace
                                            to={`/admin/evals/${slug}/surveys`}
                                        />
                                    )
                                }
                            />
                            <Route
                                path=":client/surveys"
                                element={<SurveysWizardPage />}
                            />
                        </Route>
                        <Route element={<FullLayout />}>
                            <Route
                                path=":client/surveys/:id/results"
                                element={<SurveyResultsPage />}
                            />
                        </Route>
                    </Route>
                </Route>

                {/* Catch-all route */}
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </BrowserRouter>
    );
};

export default Router;
